<div>
	<div class="Status_{{this.activity_topic}}">
		{{'logs.'+this.activity_topic|translate}}
	</div>
</div>
